import { WidgetNames } from './config.type';

const commonNestedWidgetStyles = {
  [WidgetNames.QUICK_LINKS_WIDGET]: {
    name: 'Footer Quick Link',
    description: 'Quick link configuration for footer section of dropdown',
    footer: true,
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showFontStyle: true,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: true,
    disabledBgColor: true,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: true,
  },
  [WidgetNames.ACTION_BUTTON]: {
    name: 'Footer Action button',
    description: 'Action button configuration for footer section of dropdown',
    footer: true,
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showFontStyle: true,
    backGroundColor: true,
    showTextInput: true,
    disabledTextColor: true,
    disabledBgColor: true,
    showMargin: true,
    showPadding: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showLeftRightIcon: false,
    isShowNavigationToUrl: false,
    showLoadingTextInput: false,
  },
};

const accountsListingWidgetsStyles = {
  color: true,
  hAlign: true,
  vAlign: true,
  border: true,
  fontSize: true,
  showTextBold: false,
  showTextItalic: false,
  showTextUnderline: false,
  showFontStyle: true,
  showBoxShadow: true,
  backGroundColor: true,
  disabledTextColor: false,
  disabledBgColor: false,
  showMargin: true,
  showPadding: true,
  showTextInput: false,
  showQuillInput: false,
  showImageCategoryOption: false,
  iconLibrary: false,
  isShowRHSWidgetProperty: false,
  isShowNavigationToUrl: true,
  inputFieldSettings: true,
};

export type WidgetStyle = {
  [key: string]:
    | {
        color: boolean;
        hAlign: boolean;
        vAlign: boolean;
        border: boolean;
        fontSize: boolean;
        backGroundColor: boolean;
        disabledTextColor: boolean;
        disabledBgColor: boolean;
        showMargin: boolean;
        showPadding: boolean;
        showTextInput: boolean;
        showQuillInput: boolean;
        showTextBold?: boolean;
        showTextItalic?: boolean;
        showTextUnderline?: boolean;
        showImageCategoryOption: boolean;
        iconLibrary: boolean;
        isShowRHSWidgetProperty: boolean;
        showFontStyle?: boolean;
        showBoxShadow?: boolean;
        showSelectedBorderColor?: boolean;
        showInputPlaceholderColor?: boolean;
        showInputCustomStyling?: boolean;
        showTextInputFontSize?: boolean;
        showTextInputBackgroundColor?: boolean;
        isShowNavigationToUrl?: boolean;
        animationSource?: boolean;
        animationAssetLink?: boolean;
        animationUpload?: boolean;
        animationType?: boolean;
        animationContainer?: boolean;
        showLeftRightIcon?: boolean;
        showDimensionSize?: boolean;
        showOverlay?: boolean;
        inputFieldSettings?: boolean;
        showBasicInput?: boolean;
        showPrimeNgTable?: boolean;
        showTypographyClass?: boolean;
        showTypographyClassTwo?: boolean;
        isGlobalStylingWidget?: boolean;
        showInputLabel?: boolean;
        showSkeletonPreview?: boolean;
        showSkeleton?: boolean;
        showLoadingTextInput?: boolean;
        borderV2?: boolean;
        colorsV2?: boolean;
        showNoRecordsTemplate?: boolean;
        showAppBuilderPreviewState?: boolean;
      }
    | undefined;
};

export const WidgetStyleConst = {
  [WidgetNames.DROPDOWN]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showFontStyle: true,
    showBoxShadow: false,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: false,
    showOverlay: false,
  },
  [WidgetNames.BUTTON]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showFontStyle: true,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: false,
    showOverlay: false,
  },
  [WidgetNames.COMPANIES_HOUSE_WIDGET_NESTED_SEARCH_BUTTON]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showFontStyle: true,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: true,
    showOverlay: false,
    isGlobalStylingWidget: true,
  },
  [WidgetNames.CARD]: {
    color: true,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: false,
    showBoxShadow: true,
    backGroundColor: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: true,
    showOverlay: false,
    showDimensionSize: false,
  },
  [WidgetNames.MULTI_ICON_QUICK_LINK_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showFontStyle: true,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: true,
  },
  [WidgetNames.CONDITIONAL_WIDGET_IF_ELSE_CONFIG]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showFontStyle: true,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: true,
    showLeftRightIcon: true,
    showBasicInput: false,
  },
  [WidgetNames.QUICK_LINKS_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showFontStyle: true,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: true,
    disabledBgColor: true,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: true,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: true,
    showOverlay: true,
  },
  [WidgetNames.FORM_BUTTON_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showFontStyle: true,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: true,
    disabledBgColor: true,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: true,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: true,
    showOverlay: true,
  },
  [WidgetNames.RESEND_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showFontStyle: true,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: false,
    showOverlay: false,
  },
  [WidgetNames.NAME_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showFontStyle: true,
    showTextInputFontSize: true,
    showTextInputBackgroundColor: false,
    inputFieldSettings: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
  },
  [WidgetNames.FORM_NAME_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showFontStyle: true,
    showTextInputFontSize: true,
    showTextInputBackgroundColor: false,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
  },
  [WidgetNames.FORM_BIRTHDAY_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showFontStyle: true,
    showTextInputFontSize: true,
    showTextInputBackgroundColor: false,
  },

  [WidgetNames.PHONE_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showFontStyle: true,
    showTextInputFontSize: true,
    showTextInputBackgroundColor: false,
    inputFieldSettings: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
  },

  [WidgetNames.BIRTHDAY_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showFontStyle: true,
    showTextInputFontSize: true,
    showTextInputBackgroundColor: false,
    inputFieldSettings: true,
  },

  [WidgetNames.EMAIL_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showFontStyle: true,
    showTextInputFontSize: true,
    showTextInputBackgroundColor: false,
    inputFieldSettings: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
  },

  [WidgetNames.ADDRESS_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showFontStyle: true,
    showTextInputFontSize: true,
    showTextInputBackgroundColor: false,
    inputFieldSettings: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
  },

  [WidgetNames.PASSWORD_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showFontStyle: true,
    showTextInputFontSize: true,
    showTextInputBackgroundColor: false,
    inputFieldSettings: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
  },

  [WidgetNames.FORM_PASSWORD_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showFontStyle: true,
    showTextInputBackgroundColor: false,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
  },

  [WidgetNames.FORM_ADDRESS_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showFontStyle: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
  },

  [WidgetNames.FORM_ADDRESS_HISTORY_WIDGET]: {
    color: false,
    hAlign: true,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showFontStyle: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
  },

  [WidgetNames.CTA_BUTTON_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: false,
    backGroundColor: true,
    disabledTextColor: true,
    disabledBgColor: true,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
  },
  [WidgetNames.RECENT_TRANSACTION_LIST_WIDGET]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: false,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    inputFieldSettings: false,
    showGestures: true,
    isShowNavigationToUrl: true,
    showSkeleton: true,
  },
  [WidgetNames.LINE_WIDGET]: {
    showMargin: true,
    color: false,
    hAlign: false,
    vAlign: false,
    border: false,
    fontSize: false,
    backGroundColor: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
  },
  [WidgetNames.IMAGE_WIDGET]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: false,
    backGroundColor: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: true,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: true,
    showOverlay: true,
  },
  [WidgetNames.ADD_BENEFICIARY_WIDGET]: {
    color: true,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    showTextInput: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
    showFontStyle: true,
    showTextInputFontSize: false,
    inputFieldSettings: false,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
  },
  [WidgetNames.CURRENCY_INPUT_FIELD_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    showTextInput: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
    showInputPlaceholderColor: true,
    showInputCustomStyling: true,
  },
  [WidgetNames.PAYMENT_REF_WIDGET]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: false,
    fontSize: false,
    backGroundColor: false,
    showTextInput: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: false,
    showPadding: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: false,
    showInputPlaceholderColor: false,
    isGlobalStylingWidget: true,
    showInputLabel: true,
  },
  [WidgetNames.MANDATORY_CTA_BUTTON]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showFontStyle: true,
    backGroundColor: true,
    showTextInput: true,
    disabledTextColor: true,
    disabledBgColor: true,
    showMargin: true,
    showPadding: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showLeftRightIcon: true,
  },
  [WidgetNames.FORM_SUBMISSION_BUTTON]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showFontStyle: true,
    backGroundColor: true,
    showTextInput: true,
    disabledTextColor: true,
    disabledBgColor: true,
    showMargin: true,
    showPadding: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showLeftRightIcon: true,
    isShowNavigationToUrl: false,
  },
  [WidgetNames.ACTION_BUTTON]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showFontStyle: true,
    backGroundColor: true,
    showTextInput: true,
    disabledTextColor: true,
    disabledBgColor: true,
    showMargin: true,
    showPadding: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showLeftRightIcon: true,
    isShowNavigationToUrl: false,
    showLoadingTextInput: true,
  },
  [WidgetNames.ADD_BENEFICIARY_FASTER_PAYMENTS]: {
    color: true,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    showTextInput: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
    showFontStyle: true,
    showTextInputFontSize: false,
    inputFieldSettings: false,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
  },
  [WidgetNames.INTL_BENEFICIARY_ADDRESS]: {
    showFontStyle: true,
    color: true,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    showTextInput: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
    showTextInputFontSize: true,
    inputFieldSettings: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
  },
  [WidgetNames.EDIT_INTL_BENEFICIARY_ADDRESS]: {
    color: true,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    showTextInput: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
    inputFieldSettings: true,
  },
  [WidgetNames.PASSWORD_CHANGE]: {
    color: true,
    hAlign: true,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    showTextInput: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
    inputFieldSettings: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showFontStyle: true,
  },
  [WidgetNames.PASSWORD_FORGOT]: {
    color: true,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    showTextInput: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
    inputFieldSettings: true,
    isShowNavigationToUrl: true,
  },
  [WidgetNames.PASSWORD_ENTER_EMAIL]: {
    color: true,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: false,
    backGroundColor: true,
    showTextInput: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
    inputFieldSettings: true,
  },
  [WidgetNames.PASSWORD_UPDATE]: {
    color: true,
    hAlign: true,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    showTextInput: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
    inputFieldSettings: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showFontStyle: true,
    isShowNavigationToUrl: true,
  },
  [WidgetNames.PAYMENT_REASON_WIDGET]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: false,
    fontSize: false,
    backGroundColor: false,
    showTextInput: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: false,
    showPadding: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: false,
    isGlobalStylingWidget: true,
    showInputLabel: true,
  },
  [WidgetNames.PAYMENT_RAIL_SELECTOR_WIDGET]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: false,
    fontSize: false,
    backGroundColor: false,
    showTextInput: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: false,
    showPadding: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: false,
    isGlobalStylingWidget: true,
    showInputLabel: true,
  },
  [WidgetNames.AIRWALLEX_RFI_WIDGET]: {
    color: true,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showFontStyle: true,
  },
  [WidgetNames.AIRWALLEX_KYC_WIDGET]: {
    color: true,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showFontStyle: true,
  },
  [WidgetNames.SUMSUB_WIDGET]: {
    color: true,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showFontStyle: true,
  },
  [WidgetNames.IFRAME_WIDGET]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: false,
    backGroundColor: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
  },
  [WidgetNames.PISP_BANK_LIST_WIDGET]: {
    color: true,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: true,
    showBoxShadow: false,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: true,
    inputFieldSettings: true,
    showLoadingTextInput: true,
    showNoRecordsTemplate: true,
  },
  [WidgetNames.PISP_CHECK_BILLING_REQUEST_LOADER]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: false,
    fontSize: false,
    backGroundColor: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: false,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showLeftRightIcon: true,
  },
  [WidgetNames.GOCARDLESS_COMPLIANCE_WIDGET]: {
    color: false,
    colorsV2: true,
    borderV2: true,
    hAlign: true,
    vAlign: true,
    border: false,
    fontSize: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    backGroundColor: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: false,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: false,
    showFontStyle: true,
  },
  [WidgetNames.BACK_BUTTON_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showFontStyle: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: true,
    isShowRHSWidgetProperty: true,
    showBoxShadow: true,
    showOverlay: true,
  },
  [WidgetNames.FORWARD_BUTTON_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showFontStyle: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: true,
    isShowRHSWidgetProperty: true,
    showBoxShadow: true,
    showOverlay: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
  },
  [WidgetNames.TEXT_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: false,
    showFontStyle: false,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
    showSkeletonPreview: true,
  },
  [WidgetNames.PAYMENT_CANCELLATION_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: false,
    showFontStyle: false,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
    showSkeletonPreview: true,
  },
  [WidgetNames.CANCEL_PAYMENTS_INFO_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: false,
    showFontStyle: false,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
    showSkeletonPreview: true,
  },
  [WidgetNames.CARD_PIN]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showFontStyle: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
  },
  [WidgetNames.MULTI_ROLE_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: false,
    border: true,
    fontSize: false,
    backGroundColor: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    inputFieldSettings: false,
  },

  [WidgetNames.USER_DETAIL_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: false,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
  },

  [WidgetNames.CONTACT_DETAIL_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: false,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
  },
  [WidgetNames.IMPORT_USER_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: false,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
  },
  [WidgetNames.ACCOUNT_LIST_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: false,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
  },
  [WidgetNames.LOGOUT]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showFontStyle: true,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: true,
    disabledBgColor: true,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: true,
    isShowRHSWidgetProperty: false,
  },
  [WidgetNames.SWITCH_NAVIGATOR_QUICK_LINK]: {
    color: true,
    hAlign: true,
    vAlign: false,
    border: true,
    fontSize: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showFontStyle: true,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: true,
    disabledBgColor: true,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
  },
  [WidgetNames.BENEFICIARY_SELECTION_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showFontStyle: true,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    inputFieldSettings: false,
    isShowNavigationToUrl: true,
    nestedWidgets: commonNestedWidgetStyles,
    showGestures: true,
    showSkeleton: true,
    showAppBuilderPreviewState: true,
  },
  [WidgetNames.LOTTIE_ANIMATION]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: false,
    showBoxShadow: true,
    backGroundColor: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    animationSource: true,
    animationAssetLink: true,
    animationUpload: true,
    animationType: true,
    animationContainer: true,
  },
  [WidgetNames.PROFILE_PICTURE_WIDGET]: {
    color: false,
    hAlign: true,
    vAlign: false,
    border: true,
    fontSize: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: false,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showDimensionSize: true,
  },
  [WidgetNames.NOTIFICATION_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: true,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: true,
    isShowRHSWidgetProperty: false,
  },
  [WidgetNames.NOTIFICATION_BELL_WIDGET]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: false,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: true,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: true,
  },
  [WidgetNames.NOTIFICATION_LIST_WIDGET]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: false,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showGestures: true,
    showSkeleton: true,
    showAppBuilderPreviewState: true,
  },
  [WidgetNames.SUPPORT_CHAT_LIST_WIDGET]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: false,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showGestures: true,
    isShowNavigationToUrl: true,
    showSkeleton: true,
    showAppBuilderPreviewState: true,
  },
  [WidgetNames.BIOMETRICS_AUTHENTICATION_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: true,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: true,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: true,
  },
  [WidgetNames.CURRENCY_ACCOUNTS_LISTING_WIDGET]: {
    ...accountsListingWidgetsStyles,
    inputFieldSettings: false,
    showGestures: true,
    showSkeleton: true,
    showAppBuilderPreviewState: true,
  },
  [WidgetNames.LANDING_ACCOUNTS_LISTING]: {
    ...accountsListingWidgetsStyles,
    inputFieldSettings: false,
    showGestures: true,
    showSkeleton: true,
    showAppBuilderPreviewState: true,
  },
  [WidgetNames.BANK_LISTING_WIDGET]: {
    ...accountsListingWidgetsStyles,
    isShowNavigationToUrl: false,
    showLoadingTextInput: true,
    showNoRecordsTemplate: true,
    showTextInput: true,
    showSkeleton: true,
    showAppBuilderPreviewState: true,
  },
  [WidgetNames.ACCOUNTS_CONTEXT_DROPDOWN]: {
    color: false,
    hAlign: true,
    vAlign: true,
    border: false,
    fontSize: true,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: true,
    showBoxShadow: true,
    backGroundColor: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    showLeftRightIcon: true,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: false,
    inputFieldSettings: true,
    nestedWidgets: commonNestedWidgetStyles,
    showNoRecordsTemplate: true,
  },
  [WidgetNames.ACCOUNT_SELECTION_WIDGET]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: true,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: true,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showNoRecordsTemplate: true,
    showLoadingTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    showLeftRightIcon: true,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: false,
    inputFieldSettings: false,
  },
  [WidgetNames.BULK__PAYMENT_ACCOUNTS_LISTING_WIDGET]: {
    ...accountsListingWidgetsStyles,
    inputFieldSettings: false,
  },
  [WidgetNames.ADD_CURRENCY_ACCOUNT_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: true,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    inputFieldSettings: true,
  },

  [WidgetNames.EXCHANGE_CURRENCY_WIDGET]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: false,
    showBoxShadow: false,
    backGroundColor: true,
    disabledTextColor: true,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    inputFieldSettings: true,
  },

  [WidgetNames.EXCHANGE_QUOTE_WIDGET]: {
    color: true,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: true,
    showFontStyle: true,
    showTextInputFontSize: false,
    showTextInputBackgroundColor: false,
  },

  [WidgetNames.EXCHANGE_QUOTE_SUMMARY]: {
    color: true,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: true,
    showFontStyle: true,
    showTextInputFontSize: false,
    showTextInputBackgroundColor: false,
  },

  [WidgetNames.INTERNATIONAL_CURRENCY_COUNTRY]: {
    color: true,
    hAlign: true,
    vAlign: false,
    border: true,
    fontSize: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: false,
    showBoxShadow: true,
    backGroundColor: true,
    showTextInput: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    inputFieldSettings: true,
  },
  [WidgetNames.EDIT_BENEFICIARY_INTERNATIONAL_CURRENCY_COUNTRY]: {
    color: true,
    hAlign: true,
    vAlign: false,
    border: true,
    fontSize: true,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: false,
    showBoxShadow: true,
    backGroundColor: true,
    showTextInput: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    inputFieldSettings: true,
  },
  [WidgetNames.EDIT_BENEFICIARY_INTL_NEW_CURRENCY_COUNTRY]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: false,
    showBoxShadow: true,
    backGroundColor: true,
    showTextInput: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    inputFieldSettings: false,
  },
  [WidgetNames.INTERNATIONAL_BENEFICIARY_CREDENTIALS_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: true,
    showFontStyle: true,
    showTextInputFontSize: true,
    showTextInputBackgroundColor: false,
    inputFieldSettings: true,
  },
  [WidgetNames.EDIT_INTERNATIONAL_BENEFICIARY_CREDENTIALS_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: true,
    showFontStyle: true,
    showTextInputFontSize: false,
    showTextInputBackgroundColor: false,
    inputFieldSettings: true,
  },
  [WidgetNames.FILE_UPLOAD_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: false,
    showBoxShadow: true,
    backGroundColor: true,
    showTextInput: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: true,
    isShowRHSWidgetProperty: false,
  },
  [WidgetNames.UPLOAD_FILE_WITH_POPUP_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: false,
    showBoxShadow: true,
    backGroundColor: true,
    showTextInput: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: true,
    isShowRHSWidgetProperty: false,
  },
  [WidgetNames.VERIFICATION_ORGANISATION_COMPANY_NAME]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: false,
    fontSize: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: false,
    showBoxShadow: false,
    backGroundColor: false,
    showTextInput: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: false,
    showPadding: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    inputFieldSettings: false,
    isGlobalStylingWidget: true,
    showInputLabel: true,
  },
  [WidgetNames.EDIT_ADDRESS_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: false,
    border: true,
    fontSize: true,
    showFontStyle: true,
    backGroundColor: true,
    showTextInput: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
    inputFieldSettings: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showTextInputFontSize: true,
  },
  [WidgetNames.EDIT_BENEFICIARY_ADDRESS_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: false,
    border: true,
    fontSize: true,
    showFontStyle: true,
    backGroundColor: true,
    showTextInput: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
    inputFieldSettings: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showTextInputFontSize: true,
  },
  [WidgetNames.RANGE_CALENDAR_WIDGET]: {
    color: true,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: false,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
  },
  [WidgetNames.OTP_VERIFICATION]: {
    color: true,
    hAlign: true,
    vAlign: false,
    border: true,
    fontSize: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showFontStyle: true,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showTextInputFontSize: true,
    inputFieldSettings: true,
    showBasicInput: false,
  },
  [WidgetNames.INTL_BENEFICIARY_ADDED]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showFontStyle: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
  },
  [WidgetNames.EDIT_BENEFICIARY_WIDGET]: {
    color: true,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    showTextInput: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showQuillInput: false,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
    inputFieldSettings: true,
  },

  [WidgetNames.DESKTOP_BULK_PAYMENT_HISTORY_LISTING_WIDGET]: {
    color: true,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: false,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
    inputFieldSettings: false,
  },
  [WidgetNames.DESKTOP_BULK_PAYMENT_LISTING_WIDGET]: {
    color: true,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: false,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
    inputFieldSettings: false,
  },
  [WidgetNames.ONBOARDING_BACK_NEXT_BUTTON]: {
    color: true,
    hAlign: true,
    vAlign: false,
    border: true,
    fontSize: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showFontStyle: true,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: true,
    isShowRHSWidgetProperty: false,
    showTextInputFontSize: false,
    inputFieldSettings: false,
    showOverlay: true,
  },
  [WidgetNames.ONBOARDING_BUTTON]: {
    color: true,
    hAlign: true,
    vAlign: false,
    border: true,
    fontSize: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showFontStyle: true,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: true,
    isShowRHSWidgetProperty: false,
    showTextInputFontSize: false,
    inputFieldSettings: false,
  },
  [WidgetNames.COPY_SHARE_CONTENT]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showFontStyle: true,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    showLeftRightIcon: false,
    isShowRHSWidgetProperty: false,
  },
  [WidgetNames.TRANSACTION_BUTTON]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: false,
    showBoxShadow: false,
    backGroundColor: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: false,
    showOverlay: false,
  },
  [WidgetNames.TRANSACTION_LIST]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: false,
    showBoxShadow: false,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: false,
    showOverlay: false,
  },
  [WidgetNames.FREEZE_CARD_TOGGLE_SWITCH]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: true,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: true,
    isShowRHSWidgetProperty: false,
  },
  [WidgetNames.CARDS_WIDGET]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: true,
    showBoxShadow: true,
    backGroundColor: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: false,
    showOverlay: false,
  },
  [WidgetNames.CARD_SENSITIVE_DETAILS]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showFontStyle: true,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: true,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: false,
    showOverlay: false,
  },
  [WidgetNames.TIMER_BUTTON]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showTextBold: true,
    showTextItalic: true,
    showTextUnderline: true,
    showFontStyle: true,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    isShowNavigationToUrl: false,
    showOverlay: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    inputFieldSettings: true,
    showPrimeNgTable: true,
  },
  [WidgetNames.DESKTOP_PAYMENT_REQUEST_PENDING_APPROVED_LISTING_WIDGET]: {
    color: true,
    hAlign: true,
    vAlign: true,
    border: true,
    fontSize: true,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: true,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: true,
    inputFieldSettings: false,
    showPrimeNgTable: true,
  },
  [WidgetNames.CARD_NAME_WIDGET]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: false,
    showBoxShadow: false,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: false,
    inputFieldSettings: false,
    showPrimeNgTable: false,
  },
  [WidgetNames.ADD_TO_GOOGLE_PAY_BUTTON]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: false,
    fontSize: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: false,
    showBoxShadow: false,
    backGroundColor: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: false,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: false,
    inputFieldSettings: false,
    showPrimeNgTable: false,
  },
  [WidgetNames.ADD_TO_APPLE_WALLET_BUTTON]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: false,
    fontSize: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: false,
    showBoxShadow: false,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: false,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: false,
    inputFieldSettings: false,
    showPrimeNgTable: false,
  },
  [WidgetNames.THEME_SELECTOR]: {
    color: true,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showBoxShadow: true,
    showImageCategoryOption: false,
    iconLibrary: true,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: false,
    isGlobalStylingWidget: false,
  },
  [WidgetNames.CURRENCY_SELECTOR_WIDGET]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: false,
    fontSize: false,
    backGroundColor: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: false,
    showPadding: false,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    isGlobalStylingWidget: true,
    showInputLabel: true,
  },
  [WidgetNames.DISPLAY_DOCUMENT_WIDGET]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: true,
    showBoxShadow: true,
    fontSize: false,
    backGroundColor: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showFontStyle: false,
    showTextInputFontSize: false,
    showTextInputBackgroundColor: false,
  },
  [WidgetNames.BENEFICIARY_TYPE_WIDGET]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: false,
    fontSize: false,
    backGroundColor: false,
    showTextInput: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: false,
    showPadding: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: false,
    showInputPlaceholderColor: false,
    isGlobalStylingWidget: true,
    showInputLabel: true,
  },
  [WidgetNames.BENEFICIARY_COUNTRY_CURRENCY_WIDGET]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: false,
    fontSize: false,
    backGroundColor: false,
    showTextInput: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: false,
    showPadding: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: false,
    showInputPlaceholderColor: false,
    isGlobalStylingWidget: true,
    showInputLabel: false,
  },
  [WidgetNames.BENEFICIARY_CREDENTIALS_WIDGET]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: false,
    fontSize: false,
    backGroundColor: false,
    showTextInput: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: false,
    showPadding: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: false,
    showInputPlaceholderColor: false,
    isGlobalStylingWidget: true,
    showInputLabel: true,
  },
  [WidgetNames.BENEFICIARY_ADDRESS_WIDGET]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: false,
    fontSize: false,
    backGroundColor: false,
    showTextInput: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: false,
    showPadding: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: false,
    showInputPlaceholderColor: false,
    isGlobalStylingWidget: true,
    showInputLabel: true,
  },
  [WidgetNames.BENEFICIARY_PAYMENT_RAIL_WIDGET]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: false,
    fontSize: false,
    backGroundColor: false,
    showTextInput: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: false,
    showPadding: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: false,
    showInputPlaceholderColor: false,
    isGlobalStylingWidget: true,
    showInputLabel: true,
  },
  [WidgetNames.CHART_WIDGET]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: false,
    borderV2: true,
    colorsV2: true,
    fontSize: false,
    backGroundColor: false,
    showTextInput: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
    showInputPlaceholderColor: false,
  },
  [WidgetNames.DOCUMENT_LISTING_WIDGET]: {
    color: false,
    colorsV2: true,
    borderV2: true,
    hAlign: true,
    vAlign: true,
    showLeftRightIcon: true,
    border: false,
    fontSize: false,
    backGroundColor: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showFontStyle: false,
    showTextInputBackgroundColor: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showBoxShadow: true,
    showSkeleton: true,
  },
  [WidgetNames.ACCOUNT_REQUEST_LIST_WIDGET]: {
    color: false,
    colorsV2: false,
    borderV2: true,
    hAlign: false,
    vAlign: false,
    showLeftRightIcon: false,
    border: false,
    fontSize: false,
    backGroundColor: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showFontStyle: false,
    showTextInputBackgroundColor: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showBoxShadow: false,
  },
  [WidgetNames.MULTI_CURRENCY_WIDGET]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: false,
    fontSize: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: false,
    showBoxShadow: false,
    backGroundColor: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: false,
    showPadding: false,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    showLeftRightIcon: false,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: false,
    inputFieldSettings: false,
    showInputLabel: true,
  },
  [WidgetNames.GENERIC_CAROUSEL_WIDGET]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: false,
    fontSize: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: false,
    backGroundColor: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
    showMargin: true,
    showPadding: true,
    colorsV2: true,
    borderV2: true,
  },
  [WidgetNames.SUPPORT_CHAT_WIDGET]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: false,
    fontSize: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: false,
    backGroundColor: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: true,
    isShowRHSWidgetProperty: false,
    showBoxShadow: false,
    showMargin: false,
    showPadding: false,
    colorsV2: false,
    borderV2: false,
  },
  [WidgetNames.PRODUCTS_LISTING_WIDGET]: {
    color: true,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: false,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: true,
    showNoRecordsTemplate: true,
    showLoadingTextInput: true,
    inputFieldSettings: false,
    showSkeleton: true,
  },
  [WidgetNames.TOOLTIP_WIDGET]: {
    color: false,
    hAlign: false,
    vAlign: false,
    border: false,
    fontSize: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: false,
    showBoxShadow: false,
    backGroundColor: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: false,
    showPadding: false,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: true,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: false,
    showNoRecordsTemplate: false,
    showLoadingTextInput: false,
    inputFieldSettings: false,
  },
  [WidgetNames.COMPANIES_HOUSE_SEARCH_WIDGET]: {
    color: true,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showFontStyle: false,
    showBoxShadow: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    isShowNavigationToUrl: false,
    showNoRecordsTemplate: false,
    showLoadingTextInput: false,
    inputFieldSettings: false,
  },
  [WidgetNames.COMPANIES_HOUSE_LISTING_WIDGET]: {
    color: false,
    colorsV2: true,
    borderV2: true,
    hAlign: false,
    vAlign: false,
    border: false,
    fontSize: false,
    backGroundColor: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showFontStyle: false,
    showTextInputBackgroundColor: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showBoxShadow: true,
    isShowNavigationToUrl: true,
    showSkeleton: true,
  },
  [WidgetNames.COMPANIES_HOUSE_DIRECTOR_SELECTION_WIDGET]: {
    color: false,
    colorsV2: true,
    borderV2: true,
    hAlign: false,
    vAlign: false,
    border: false,
    fontSize: false,
    backGroundColor: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showFontStyle: false,
    showTextInputBackgroundColor: false,
    showTextBold: false,
    showTextItalic: false,
    showTextUnderline: false,
    showBoxShadow: true,
    isShowNavigationToUrl: true,
    showNoRecordsTemplate: true,
    showLoadingTextInput: true,
    showSkeleton: true,
    showAppBuilderPreviewState: true,
  },
  [WidgetNames.AUTHENTICATION_FLOW_WIDGET]: {
    color: true,
    hAlign: false,
    vAlign: false,
    border: true,
    fontSize: true,
    backGroundColor: true,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: false,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
    isGlobalStylingWidget: true,
  },
  [WidgetNames.VARIABLE_RECURRING_PAYMENT_LIST_WIDGET]: {
    color: false,
    colorsV2: true,
    borderV2: true,
    hAlign: false,
    vAlign: false,
    border: false,
    fontSize: false,
    backGroundColor: false,
    disabledTextColor: false,
    disabledBgColor: false,
    showMargin: true,
    showPadding: true,
    showTextInput: true,
    showQuillInput: false,
    showImageCategoryOption: false,
    iconLibrary: false,
    isShowRHSWidgetProperty: false,
    showBoxShadow: true,
    showNoRecordsTemplate: true,
    showLoadingTextInput: true,
    isShowNavigationToUrl: true,
    showGestures: true,
    showSkeleton: true,
  },
} as WidgetStyle;
